/** Escape string for safe use inside RegExp constructor. */
export function escapeRegExp(str) {
  return String(str).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Split text into alternating plain / highlighted segments for query tokens (AND-style token list).
 * @returns {{ key: string, text: string, mark: boolean }[]}
 */
export function splitHighlight(text, query) {
  const s = text == null ? '' : String(text);
  const rawTokens = (query || '')
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);
  const tokens = [...new Set(rawTokens.map(escapeRegExp))];
  if (!s || tokens.length === 0) {
    return [{ key: '0', text: s, mark: false }];
  }

  try {
    const re = new RegExp(`(${tokens.join('|')})`, 'gi');
    const out = [];
    let idx = 0;
    let last = 0;
    for (const m of s.matchAll(re)) {
      if (m.index > last) {
        out.push({ key: `t-${idx}`, text: s.slice(last, m.index), mark: false });
        idx += 1;
      }
      out.push({ key: `m-${idx}`, text: m[0], mark: true });
      idx += 1;
      last = m.index + m[0].length;
    }
    if (last < s.length) {
      out.push({ key: `t-${idx}`, text: s.slice(last), mark: false });
    }
    return out.length > 0 ? out : [{ key: '0', text: s, mark: false }];
  } catch {
    return [{ key: '0', text: s, mark: false }];
  }
}
